module.exports = __webpack_public_path__ + "img/A0101.74524b5b.png";